import React from 'react';
import { FormattedMessage } from 'react-intl';

import CmsTextColorSelector from 'components/cms/settings/components/CmsTextColorSelector';

import FormInput from 'components/forms/FormInput';
import FormRichEditor from 'components/forms/FormRichEditor';
import FormTextarea from 'components/forms/FormTextarea';

export default class CmsElementSignupForm extends React.Component {
  render() {
    const {
      intl: { messages },
      setParam,
      getParamValue,
      navigateBack,
    } = this.props;

    return (
      <>
        <div className="m-b-20">
          <a
            href="#back"
            className="m-r-15 bg-master-light fs-14 p-l-15 p-r-15 p-t-5 p-b-5 text-master b-rad-lg"
            onClick={navigateBack}
          >
            <i className="fa fa-angle-left m-r-5" /> {messages.back}
          </a>

          <b>{messages.signup_form}</b>
        </div>

        <div className="form-group-attached">
          <CmsTextColorSelector label={messages.text_color} {...this.props} />
          <FormInput label={messages.title} name="title" onChange={setParam} value={getParamValue('title')} />
          <FormRichEditor
            label={messages.content}
            name="content"
            onChange={setParam}
            value={getParamValue('content')}
          />

          <FormTextarea
            label={messages.signup_legal_explanation}
            name="signupAgreementText"
            onChange={setParam}
            value={getParamValue('signupAgreementText')}
            infoText={
              <p className="hint-text fs-11 text-left p-t-10" style={{ lineHeight: 1 }}>
                {'{terms}: '}{' '}
                <FormattedMessage
                  id="will_become_link_with_title_title"
                  values={{ title: messages.signup_agreement_text_terms }}
                />
                <br />
                {'{data_use}: '}{' '}
                <FormattedMessage
                  id="will_become_link_with_title_title"
                  values={{ title: messages.signup_agreement_text_data_use }}
                />
                <br />
              </p>
            }
            rows={4}
          />
          <FormInput
            label={messages.button_text}
            name="buttonTitle"
            onChange={setParam}
            value={getParamValue('buttonTitle', '')}
          />
        </div>
      </>
    );
  }
}
